export default __webpack_public_path__ + "static/media/LA.f36bc193.svg";